<template>
  <div>
    <v-dialog
      max-width="550px"
      v-model="show"
      scrollable
    >
      <v-card>
        <v-card-title>
          Compensation Types
          <v-spacer></v-spacer>
          <v-text-field
            dense
            hide-details
            v-model="search"
            append-icon="mdi-magnify"
            label="Search type"
            class="mr-2"
          ></v-text-field>
          <v-btn
            icon
            @click.prevent="show = false"
          >
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text class="pt-3">
          <v-data-table
            dense
            fixed-header
            :headers="compensation_types_headers"
            :items="compensationTypes"
            :search="search"
            :hide-default-footer="true"
          >
            <!-- Items -->
            <template v-slot:[`item.Actions`]="{ item }">
              <v-btn icon small
                @click.prevent="getCompensationTypeDetailsById(item.Compensation_Type_ID)"
                color="primary"
              >
                <v-icon>mdi-pencil-circle</v-icon>
              </v-btn>
            </template>
          </v-data-table>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn small color="success" @click="addNewCompensationType">Add</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="deleteCompensationTypeDialog"
      max-width="350"
    >
      <v-card>
        <v-card-title>Remove Compensation Type</v-card-title>
        <v-divider></v-divider>
        <v-card-text class="pt-3">
          Are you sure?
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-btn small color="primary" @click="deleteCompensationTypeDialog = false">Cancel</v-btn>
          <v-spacer></v-spacer>
          <v-btn small color="red darken-4 white--text" @click="removeCompensationType">Yes</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <CompensationTypeEditor
      v-model="showCompensationTypeEditor"
      :addMode="addMode"
      :currentCompensationType="selectedCompensationType"
    ></CompensationTypeEditor>
  </div>
</template>
<script>
import { getApiErrorMessage } from '@/utils/apiError'

export default {
  name: 'CompensationTypeManager',
  props: {
    value: {
      required: false
    }
  },
  components: {
    CompensationTypeEditor: () => import('@/components/payroll/CompensationTypeEditor.vue')
  },
  data () {
    return {
      addMode: false,
      showEditor: false,
      selectedCompensationType: {},
      deleteCompensationTypeDialog: false,
      search: '',
      compensationTypes: null,
      compensation_types_headers: [
        {
          text: 'Name of Compensation',
          value: 'Compensation_Name',
          divider: true,
          class: 'px-2 text-no-wrap'
        },
        {
          text: '',
          value: 'Actions',
          cellClass: 'px-2 text-no-wrap',
          class: 'px-2 text-no-wrap',
          width: '5%',
          sortable: false
        }
      ]
    }
  },
  computed: {
    show: {
      get () {
        return this.value
      },
      set (value) {
        this.getCompensationTypes()
        this.$emit('input', value)
      }
    },
    showCompensationTypeEditor: {
      get () {
        return this.showEditor
      },
      set (value) {
        this.getCompensationTypes()
        this.showEditor = value
      }
    },
    user () {
      return this.$store.getters.getUser
    }
  },
  mounted () {
    this.getCompensationTypes()
  },
  methods: {
    getCompensationTypes () {
      this.axios.get('/api/payroll/compensation_types', {
        headers: {
          Authorization: 'Bearer ' + this.user.token
        }
      }).then(res => {
        this.compensationTypes = res.data
      }).catch(error => {
        const errorMsg = getApiErrorMessage(error)
        this.$store.dispatch('setError', { errorMsg })
      })
    },
    getCompensationTypeDetailsById (id) {
      this.axios.get(`/api/payroll/compensation_type/${id}`, {
        headers: {
          Authorization: 'Bearer ' + this.user.token
        }
      }).then(res => {
        this.selectedCompensationType = res.data[0]
        this.addMode = false
        this.showCompensationTypeEditor = true
      }).catch(error => {
        const errorMsg = getApiErrorMessage(error)
        this.$store.dispatch('setError', { errorMsg })
      })
    },
    addNewCompensationType () {
      this.selectedCompensationType.Compensation_Type_ID = null
      this.selectedCompensationType.Compensation_Name = ''
      this.addMode = true
      this.showCompensationTypeEditor = true
    },
    deleteCompensationType (id) {
      this.selectedCompensationType.Compensation_Type_ID = id
      this.deleteCompensationTypeDialog = true
    },
    removeCompensationType () {
      this.axios.delete(`/api/payroll/compensation_type/${this.selectedCompensationType.Compensation_Type_ID}`, {
        headers: {
          Authorization: 'Bearer ' + this.user.token
        }
      }).then(res => {
        this.$store.dispatch('setSuccess', { successMsg: 'Compensation Type successfully deleted' })
        this.getCompensationTypes()
        this.deleteCompensationTypeDialog = false
      }).catch(error => {
        const errorMsg = getApiErrorMessage(error)
        this.$store.dispatch('setError', { errorMsg })
      })
    }
  }
}
</script>
